import {Component, HostBinding} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {GenericResourceApiService} from '@catfeatures/services/generic-resource-api.service';
import {EntityForm} from '@catmodules/ui-models/shared/entity-form';
import {sortByLabelFunc} from "@catcore/utils";
import {FeatureTypeService} from "@catcore/services";
import {FeatureGgwFixedRoutesService} from "@catmodels/ggw-fixed-routes/services/feature-ggw-fixed-routes.service";
import {isNullOrUndefined} from 'util';

const componentBaseName = 'feature-ggw-fixed-routes-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-ggw-fixed-routes-form',
  templateUrl: './feature-ggw-fixed-routes-form.component.html',
})
export class FeatureGgwFixedRoutesFormComponent extends EntityForm {
  @HostBinding('class') classNames = defaultClassNames;

  outputOptions = [];

  private staticInputOptions = [
    {value: null, label: 'Auto-resolve by CAT'}
  ];

  inputOptions = [
    ...this.staticInputOptions
  ];

  constructor(formBuilder: FormBuilder,
              private resourceService: GenericResourceApiService,
              private featureService: FeatureTypeService,
              private featureGgwFixedRoutesService: FeatureGgwFixedRoutesService) {
    super(formBuilder);
    super.setSubmitNullValueFields(['input']);
  }

  protected afterUpdateForm() {
    this.updateOutputOptions(this.formData._embedded.source);
    this.updateInputOptions(this.formData._embedded.sink);
  }

  protected afterDelete() {
    this.featureService.refreshCurrent();
    this.form = null;
  }

  private resolveIdForDevice(resource): string {
    let resourceId = null;

    if (resource._links && resource._links.sink) {
      resourceId = resource._links.sink.href;
    }
    return resourceId;

  }

  private updateOutputOptions(source) {
    this.outputOptions = [];
    if (source) {
      source.outputs.forEach((output) => {
        this.outputOptions.push({value: output, label: output});
      });
      this.outputOptions.sort(sortByLabelFunc);
    }
  }

  private updateInputOptions(sink) {
    let inputOptions = [];
    if (sink) {
      sink.inputs.forEach((input) => {
        inputOptions.push({value: input, label: input});
      });
      if (!isNullOrUndefined(sink.gui_pages)) {
        const pages = sink.gui_pages.map((page) => { return {label: page, value: page}; });
        inputOptions = this.featureGgwFixedRoutesService.concatArraysUnique(inputOptions, pages);
        console.warn('Input options: ', inputOptions);
      }
      inputOptions.sort(sortByLabelFunc);
    }
    this.inputOptions = [
      ...this.staticInputOptions,
      ...inputOptions
    ];
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-fixed-routes/components/feature-ggw-fixed-routes-form/feature-ggw-fixed-routes-form.component.ts